export const INVALID_TITLE_CHARACTERS_ERROR = `The characters ':', ';', and ',' are not allowed`;
export const INVALID_TITLE_CHARS = new Set([':', ';', ',']);
export const REPORT_TITLE_LENGTH_ERROR = ' character limit exceeded';
export const MISSING_REPORT_TITLE_ERROR = 'Give this PDF a title';
